// assets/offers-static.js
// Static renderer — calculates per-item prices and "You save" as % of the base price,
// rounding to the nearest whole rupee (no paise). pct1 is applied to the 1-item price.

(function(){
  function formatINRFromCents(cents) {
    var rupees = (cents/100).toFixed(2);
    if (rupees.indexOf('.00') !== -1) rupees = rupees.replace('.00','');
    return '₹' + rupees.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function initOffer(el) {
    if (!el) return;

    var baseCents = parseInt(el.getAttribute('data-base-price-cents'), 10) || 0;
    var pct1 = parseFloat(el.getAttribute('data-pct1')) || 0;
    var pct2 = parseFloat(el.getAttribute('data-pct2')) || 0;
    var pct3 = parseFloat(el.getAttribute('data-pct3')) || 0;
    var titleText = el.getAttribute('data-title-text') || 'BUY';
    var ctaText = el.getAttribute('data-cta-text') || '% More offers ›';
    var accentColor = el.getAttribute('data-accent-color') || '#c77b5d';
    var savePrefix = el.getAttribute('data-save-prefix') || 'You save';

    // Canonical base in whole rupees (rounded)
    var baseRupees = Math.round(baseCents / 100);

    // Compute per-item prices in rupees by applying respective pct discounts, then round to nearest rupee
    var per1R = Math.round(baseRupees * (100 - pct1) / 100);
    var per2R = Math.round(baseRupees * (100 - pct2) / 100);
    var per3R = Math.round(baseRupees * (100 - pct3) / 100);

    // Savings are the visible difference between base and rounded per-item price
    var save1R = baseRupees - per1R;
    var save2R = baseRupees - per2R;
    var save3R = baseRupees - per3R;

    // Convert to cents for the formatter
    var per1 = per1R * 100;
    var per2 = per2R * 100;
    var per3 = per3R * 100;

    var save1 = save1R * 100;
    var save2 = save2R * 100;
    var save3 = save3R * 100;

    // Determine best price (lowest per-item)
    var best = Math.min(per1, per2, per3);

    // DOM nodes
    var elPrice1 = el.querySelector('.js-price-1');
    var elPrice2 = el.querySelector('.js-price-2');
    var elPrice3 = el.querySelector('.js-price-3');
    var elSave1 = el.querySelector('.js-save-1');
    var elSave2 = el.querySelector('.js-save-2');
    var elSave3 = el.querySelector('.js-save-3');
    var elBestPrice = el.querySelector('.js-best-price');
    var elBestLabel = el.querySelector('.js-best-label');
    var elCta = el.querySelector('.js-cta');

    if (elPrice1) elPrice1.textContent = formatINRFromCents(per1);
    if (elPrice2) elPrice2.textContent = formatINRFromCents(per2);
    if (elPrice3) elPrice3.textContent = formatINRFromCents(per3);

    if (elSave1) elSave1.textContent = savePrefix + ' ' + formatINRFromCents(save1);
    if (elSave2) elSave2.textContent = savePrefix + ' ' + formatINRFromCents(save2);
    if (elSave3) elSave3.textContent = savePrefix + ' ' + formatINRFromCents(save3);

    if (elBestPrice) elBestPrice.textContent = formatINRFromCents(best);
    if (elCta) elCta.textContent = ctaText;

    if (elBestLabel) {
      var lbl = ' ';
      if (best === per3) lbl += 'Get it for ' + formatINRFromCents(best) + ' each';
      else if (best === per2) lbl += 'Get it for ' + formatINRFromCents(best) + ' each';
      else lbl += 'Get it for ' + formatINRFromCents(best) + ' each';
      elBestLabel.textContent = lbl;
    }

    // apply accent color to CTA if present
    var ctaEl = el.querySelector('.offers-more-btn');
    if (ctaEl) ctaEl.style.background = accentColor;
  }

  document.addEventListener('DOMContentLoaded', function(){
    var blocks = document.querySelectorAll('.offers-static');
    blocks.forEach(initOffer);
  });
})();
